// Render the signup date as dd/mm/aaaa. The backend sends an ISO date; if it is not
// parseable, fall back to the raw string rather than showing "Invalid Date". UTC keeps
// a date-only value from drifting a day under the test/runtime timezone.
const FORMATTER = new Intl.DateTimeFormat('es-ES', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: 'UTC',
});

export function formatSignupDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return FORMATTER.format(date);
}
